<template>
  <div
    v-if="loading"
    :class="[
      'b-skeleton-wrapper'
    ]"
    role="alert"
    aria-live="polite"
    aria-busy="true"
  >
    <slot name="loading" />
  </div>
  <div v-else>
    <slot name="default" />
  </div>
</template>

<script>
export default {
  name: 'BSkeletonWrapper',
  props: {
    loading: Boolean
  }
}
</script>
